import React from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import envManager from 'src/utils/EnvManager';
import MaintenancePage from 'src/views/MaintenancePage';

const useStyles = makeStyles((theme) => ({
  root:{}
}));

interface ComponentSectionProps {
  children:any,
}
const MaintenanceChecker: React.FC<ComponentSectionProps> = ({children}) => {

  const classes = useStyles();

  if (envManager.isMaintenance()) return <MaintenancePage/>

  return children
}

export default MaintenanceChecker;
